"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilProject = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const hil_signal_js_1 = require("./hil-signal.js");
const hilProjectSchema = z.object({
    id: z.string().default(() => (0, cadstrom_shared_1.generateCadstromUid)(cadstrom_shared_1.CadstromObjectType.Project)),
    name: z.string(),
    modules: z.array(z.object({
        name: z.string(),
        instances: z.array(z.object({
            ref: z.string(),
            designId: z.string(),
        })),
        value: z.string().optional(),
        signals: hil_signal_js_1.HilSignal.schema.array(),
        isDnp: z.boolean().optional(),
        hideInBom: z.boolean().optional(),
        metadata: z
            .record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.record(z.string(), z.unknown()), z.undefined()]))
            .optional(),
        componentRef: z.string(),
    })),
    isDemo: z.boolean().default(false),
    updatedAt: z.coerce.date(),
});
exports.HilProject = {
    create(input) {
        return hilProjectSchema.parse(input);
    },
    schema: hilProjectSchema,
};
//# sourceMappingURL=hil-project.js.map